import { set, toggle } from "@/utils/vuex";

export default {
  setDrawer: set("drawer"),
  setColor: set("color"),
  toggleDrawer: toggle("drawer"),
  setLoader: set("loader"),
  setNotifier: set("notification"),
  setShowChat: set("showChat"),
  setVersion: set("version"),
  setPendingRequests: set("pendingRequests"),
  setAppState: set("appState"),
  setIsLoggedIn: set("isLoggedIn"),
  setPaymentStep: set("paymentStep"),
  setShowPermission: set("showPermission"),
  setReloadProgress: set("reloadProgress"),
};
